
export default function formatPhoneNumber(phoneNumber) {
	//return 'tel:'+phoneNumber.replace(/\s+/g, '').replace(/(.)(\d{4})(\d)/, '+44 ($1)$2 $3');
    return 'tel:'+phoneNumber.replace(/\s+/g, '').replace(/(.)(\d{4})(\d)/, '+44$2$3');
}
